import React from 'react';
import { experiencia } from '../utils/api';
import { APP_VERSION } from '../utils/operational';
import { attemptAutoReload } from '../utils/lazyWithRetry';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo });
    if (attemptAutoReload(error)) {
      return;
    }
    experiencia.telemetria({
      evento: 'frontend_error',
      tela: location.pathname,
      contexto: {
        version: APP_VERSION,
        error_type: error?.name || 'Error',
        message: String(error?.message || '').slice(0, 300),
        stack: String(error?.stack || '').slice(0, 500)
      }
    }).catch(() => {});
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && this.props.resetKey !== undefined && this.props.resetKey !== prevProps.resetKey) {
      this.setState({ hasError: false, error: null, errorInfo: null });
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      const requestId = this.state.error?.requestId;
      const errorMsg = String(this.state.error?.message || this.state.error || '');
      const errorStack = this.state.error?.stack || this.state.errorInfo?.componentStack || '';

      return (
        <div className="global-error" role="alert">
          <h2>Não foi possível exibir esta tela</h2>
          <p>Seu trabalho salvo não foi apagado. Tente novamente ou recarregue a tela; se o problema continuar, informe o código ao suporte.</p>
          {requestId ? <code>Código: {requestId}</code> : null}
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '12px' }}>
            <button type="button" onClick={this.handleRetry}>Tentar novamente</button>
            <button type="button" onClick={() => location.reload()}>Recarregar</button>
            <button type="button" onClick={() => { location.href = '/hoje' }}>Ir para Hoje</button>
          </div>
          {errorMsg ? (
            <details style={{ marginTop: '18px', textAlign: 'left', maxWidth: '580px', width: '100%', fontSize: '12px' }}>
              <summary style={{ cursor: 'pointer', opacity: 0.7, padding: '4px 0' }}>Detalhes técnicos</summary>
              <pre style={{ fontSize: '11px', whiteSpace: 'pre-wrap', wordBreak: 'break-all', opacity: 0.85, marginTop: '8px', background: 'rgba(0,0,0,0.35)', padding: '10px', borderRadius: '6px', overflowX: 'auto' }}>
                {errorMsg}
                {errorStack ? `\n\n${errorStack}` : ''}
              </pre>
            </details>
          ) : null}
        </div>
      );
    }
    return this.props.children;
  }
}
